const IMAGE_WIDTH = 175;

export { IMAGE_WIDTH };
